import { useRef } from "react";
import Bootbox from "../components/tools/Bootbox";
import PartnerFormSection from "../components/sections/PartnerFormSection";

export default function InquiryPartner() {
  const bootboxRef = useRef();
  return (
    <>
      <Bootbox title="提交" ref={bootboxRef}></Bootbox>
      <div className="relative py-24 overflow-hidden bg-gray-900 inquiry-partner front-color isolate sm:py-32">
        <img
          src="https://images.unsplash.com/photo-1686771416282-3888ddaf249b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2942&q=80"
          alt=""
          className="absolute inset-0 object-cover w-full h-full -z-20 blur-sm saturate-0"
        />
        <div
          className="hidden sm:absolute sm:-top-10 sm:right-1/2 sm:-z-10 sm:mr-10 sm:block sm:transform-gpu sm:blur-3xl"
          aria-hidden="true"
        >
          <div
            className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
        <div
          className="absolute -top-52 left-1/2 -z-10 -translate-x-1/2 transform-gpu blur-3xl sm:top-[-28rem] sm:ml-16 sm:translate-x-0 sm:transform-gpu"
          aria-hidden="true"
        >
          <div
            className="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-tr from-[#ff4694] to-[#776fff] opacity-20"
            style={{
              clipPath:
                "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
            }}
          />
        </div>
        <div className="px-6 mx-auto max-w-7xl lg:px-8">
          <div className="max-w-2xl mx-auto lg:mx-0">
            <h2 className="text-4xl font-bold tracking-tight text-white sm:text-6xl">
              成為合作夥伴
            </h2>
            <p className="mt-6 text-lg text-gray-300 leading-8">
              PARTNER INQUIRY
            </p>
          </div>
        </div>
      </div>
      <div className="px-4 mt-12 space-y-12 2xl:px-96 md:px-8">
        <PartnerFormSection bootboxRef={bootboxRef} />
      </div>
    </>
  );
}
